import {Col, Table} from "react-bootstrap";
import Dropzone from "react-dropzone-uploader";
import styles from "./NoteFile.module.css";
import {DeleteNoteFileConfirmationModal} from "../note/DeleteNoteFileConfirmationModal";
import {
    deleteNoteFileAsync,
    getNoteFilesByIdAsync,
    markNoteFileAsDeletable, NoteFile,
    unmarkNoteFileAsDeletable,
    uploadFile
} from "../note/noteSlice";
import {useAppSelector} from "../../app/hooks";
import {connect} from "react-redux";
import {NoteFileListItem} from "./NoteFileListItem";
import {NoteFileViewInterface} from "./NoteFileViewInterface";

export const NoteFileView = (props: NoteFileViewInterface) => {

    const noteFiles = useAppSelector((state) => state.note.files);
    const noteFileToBeDeleted = useAppSelector((state) => state.note.noteFileToBeDeleted);
    
    const noteId = props.note?.id
    
    if (!noteId)
    {
        return null;
    }
    
    const getFileUploadParams = async () => {
        const id = props.note?.id || '';
        const apiAccessToken = await props.requestApiAccessToken();
        return {
            url: `${process.env.REACT_APP_API_BASE_URL}/notes/${id}/files`,
            headers: {
                "Authorization": `Bearer ${apiAccessToken}`,
            }
        }
    }

    const handleDropZoneChangeStatus = ({meta, remove}: any, status: string, _: any[]) => {
        props.requestApiAccessToken().then ((apiToken) => {
                props.dispatch(uploadFile(status));
                if (status === 'done') {
                    remove();

                    const id = props.note?.id ? props.note.id : '';

                    props.dispatch(getNoteFilesByIdAsync({
                        apiToken: apiToken,
                        id: id
                    }));
                } 
        });
    }

    const onMarkNoteFileAsDeleted = (noteFile: NoteFile) => {
        props.dispatch(markNoteFileAsDeletable(noteFile));
    }

    const onDeleteNoteFileConfirmationOk = async () => {
        const noteId = props.note?.id ? props.note.id : '';
        const noteFileId = noteFileToBeDeleted?.id ? noteFileToBeDeleted.id : '';
        const apiToken = await props.requestApiAccessToken();

        props.dispatch(deleteNoteFileAsync({
            apiToken: apiToken,
            noteId: noteId,
            noteFileId: noteFileId
        }))
            .then((data: any) => {
                !data.error &&
                props.dispatch(getNoteFilesByIdAsync({
                    apiToken: apiToken,
                    id: noteId
                }));
            });
    }

    const onDeleteFileConfirmationModalCancel = async () => {
        props.dispatch(unmarkNoteFileAsDeletable(undefined));
    }

    return (
        <>
            <Col xs={12}>
                <Dropzone
                    getUploadParams={getFileUploadParams}
                    onChangeStatus={handleDropZoneChangeStatus}
                    styles={{dropzone: {minHeight: 200, maxHeight: 250}}}
                />
            </Col>
            <Col xs={12} className={styles.fileViewPadding}>
                <Table>
                    <tbody>
                    {noteFiles.map((file, index) =>
                        <NoteFileListItem 
                            noteId={noteId}
                            key={index} 
                            file={file}
                            getAccessToken={props.requestApiAccessToken}
                            deleteAction={onMarkNoteFileAsDeleted}/>
                    )
                    }
                    </tbody>
                </Table>
            </Col>
            <DeleteNoteFileConfirmationModal
                show={noteFileToBeDeleted !== undefined}
                onYes={onDeleteNoteFileConfirmationOk}
                onCancel={onDeleteFileConfirmationModalCancel}/>
        </>
    );

}

export default connect()(NoteFileView);
